import React from 'react';
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Unlocking Innovation With Our React Native App Kit</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
            We utilize the latest technology to develop breathtaking React Native mobile apps. Using this robust stack, we bring innovative solutions in the digital world.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>React</li>
                <li>TypeScript</li>
                <li>JavaScript</li>
                <li>Bootstrap</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Native-Centric Tools">
              <ul>
                <li>Expo</li>
                <li>React Navigation</li>
                <li>Redux Pertsist</li>
                <li>Reduxsauce</li>
                <li>Reactotron</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="UI Kits">
              <ul>
                <li>Nativebase</li>
                <li>Ignite UI</li>
                <li>UI kitten</li>
                <li>React Native Elements</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Testing Tools">
              <ul>
                <li>Jest</li>
                <li>Enzyme</li>
                <li>Detox</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Databases">
              <ul>
                <li>SQLite</li>
                <li>Firebase</li>
                <li>Pounchdb</li>
                <li>Realm</li>
                <li>AWS</li>
                <li>azure-full</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
